import { faCheckCircle } from "@fortawesome/free-solid-svg-icons"
import { GameType, IBaseID, ITournamentDeck, ITournamentPokemonGo, ITournamentVgPokemon } from "pkm-special-tool"
import React from "react"
import { makeApiCall, ServerCall, showMessage } from "../../apis/ServerCall"
import { CanLoad } from "../../utils/CanLoad"
import { EntityCRUD } from "../../utils/EntityCRUD"
import { translate } from "../../utils/LangUtils"
import { PokemonDeckList } from "./teams/PokemonDeckList"
import { PokemonGoTeamList } from "./teams/PokemonGoTeamList"
import { PokemonTeamList } from "./teams/PokemonTeamList"

export const TEAM_LIST_URL = "tournaments-team-list"

export interface ISendTeamProps{
    readonly isAdmin?: boolean
    readonly save: (fn: (id: string, success: () => void) => Promise<unknown>) => void
}

interface IProps extends IBaseID{
    readonly type: GameType
    readonly teamListKey: string
    readonly playerId?: string
}

export class SendTeamList extends CanLoad<IProps>{
    private item: ITournamentDeck | ITournamentVgPokemon | ITournamentPokemonGo[]

    constructor(props: IProps){
        super(props, null, true)
    }

    componentDidMount = () => {
        const appendUrl = this.props.playerId ? `/${this.props.playerId}` : ""

        makeApiCall({
            promise: ServerCall.get(TEAM_LIST_URL + "/" + this.props.id + appendUrl),
            onSuccess: item => this.item = item as ITournamentDeck | ITournamentVgPokemon | ITournamentPokemonGo[],
            doFinally: this.toggleLoading
        })
    }

    private save = (fn: (id: string, success: () => void) => Promise<unknown>) => fn(this.props.id, () => {
        this.toggleLoading()
        this.componentDidMount()
        showMessage(translate("masterDetail.saved"), faCheckCircle, "green")
    })

    render = () => {
        const { teamListKey, type, playerId } = this.props,
        { loading } = this.state

        return <>
            {!playerId && <h4 className="mt-2">{translate("tournaments.sendTeamList", { key: teamListKey })}</h4>}

            {
                loading ? EntityCRUD.centeredLoading() : <>
                    {
                        type === GameType.TCG && <PokemonDeckList item={this.item as ITournamentDeck} save={this.save} isAdmin={!!playerId} />
                    }
                    {
                        type === GameType.GO && <PokemonGoTeamList list={this.item as ITournamentPokemonGo[]} save={this.save} isAdmin={!!playerId} />
                    }
                    {
                        type === GameType.VGC && <PokemonTeamList item={this.item as ITournamentVgPokemon} save={this.save} isAdmin={!!playerId} />
                    }
                </>
            }
        </>
    }
}